import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { CurrencyCode, Currency, NumberQualifierService } from 'src/app/model/api-services/qualifiers/number-qualifier.service';

export type CurrencyFormat = 'S#C' | '#C' | 'S#' | 'C#' | 'Ssp#C' | 'Ssp#';

@Component({
	selector: 'app-currency-formats-sel',
	templateUrl: './currency-formats-sel.component.html',
	styleUrls: ['./currency-formats-sel.component.scss']
})
export class CurrencyFormatsSelComponent implements OnInit {

	public ready = false;

	private _code: CurrencyCode = 'USD';
	@Input()
	public set currencyCode(code: CurrencyCode) {
		const oldVal = this.value;
		if ((this._code !== code)) {
			this.value = null;

			this.ready = false;
			this._code = code;
			let i = -1;
			for (const currency of NumberQualifierService.currencies) {
				i += 1;
				if (currency.code === code) {
					this.currency = currency;
					break;
				}
			}
			this.currency = NumberQualifierService.currencies[i];
			this.currencyCodeChange.emit(code);
			this.value = oldVal;
			this.valueChange.emit(this.value);
		}
	}
	public get currencyCode(): CurrencyCode {
		return this._code;
	}
	@Output()
	public currencyCodeChange = new EventEmitter<CurrencyCode>();

	public currency: Currency = NumberQualifierService.currencies[0];

	private _val: CurrencyFormat = 'S#C';

	@Input('value')
	public set value(val: CurrencyFormat) {
		if (this._val !== val) {
			this._val = val;
			this.valueChange.emit(val);
		}
	}
	public get value(): CurrencyFormat {
		return this._val;
	}
	@Output()
	public valueChange = new EventEmitter<CurrencyFormat>();

	constructor() { }

	ngOnInit(): void {
		window.requestAnimationFrame(() => {
			this.ready = true;
		});
	}

}
